"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function IndustryCompliance() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const complianceStandards = [{
    standard: "MIL-SPEC",
    citation: "Military Identification"
  }, {
    standard: "UL 508A",
    citation: "Panel Certification"
  }, {
    standard: "OSHA",
    citation: "Safety Compliance"
  }, {
    standard: "ANSI",
    citation: "Safety Standards"
  }, {
    standard: "NFPA 70E",
    citation: "Arc Flash Safety"
  }, {
    standard: "ISO 9001",
    citation: "Quality Systems"
  }];
  return <section data-section-id="1901" id="industrycompliance" className="bg-background text-foreground py-12 md:py-16 border-t border-border">
      <div ref={ref} className={`mx-auto max-w-7xl px-6 md:px-10 lg:px-16 transition-opacity duration-700 ${isVisible ? "opacity-100" : "opacity-0"}`}>
        {}
        <div className="flex flex-col items-center text-center">
          <p className="font-default uppercase text-foreground" style={{
          fontSize: "12px",
          letterSpacing: "0.16em",
          lineHeight: 1
        }}>
            § 02 — Industry Compliance &amp; Standards
          </p>

          {}
          <div className="mt-6 flex items-center justify-center" style={{
          width: "140px"
        }}>
            <div className="h-px flex-1 bg-border" />
            <span className="inline-block bg-primary" style={{
            width: "6px",
            height: "6px",
            borderRadius: "4px"
          }} aria-hidden="true" />
          </div>
        </div>

        {}
        <div className="mt-12 md:mt-16 grid grid-cols-2 md:grid-cols-6 md:divide-x md:divide-border">
          {complianceStandards.map((mark, i) => <div data-index={i} key={i} className="px-4 py-4 md:py-2 flex items-center justify-center text-center group cursor-default">
              <p className="font-default text-foreground leading-snug" style={{
            fontSize: "14px"
          }}>
                <span className="font-bold group-hover:text-primary transition-all duration-200">
                  {mark.standard}
                </span>
                <span className="mx-1.5 text-muted-foreground">—</span>
                <span className="group-hover:text-primary transition-all duration-200">
                  {mark.citation}
                </span>
              </p>
            </div>)}
        </div>

        {}
        <div className="mt-10 flex justify-center">
          <p className="font-default italic text-muted-foreground text-center" style={{
          fontSize: "12px"
        }}>
            Evermark maintains full documentation for all specified industrial standards
          </p>
        </div>
      </div>
    </section>;
}